import { graphql } from 'react-relay';

export default graphql`
  query GrapefulClubPromo_Query {
    viewer {
      id
      ...TheGrapefulClubPromo_viewer
    }
  }
`;
